import { Input, Popover } from "antd";
import React from "react";

interface RecognizeAddressTextAreaProps {
    smartText: string;
    onTextChange: (smartText: string) => void;
}

const RecognizeAddressTextArea: React.FC<RecognizeAddressTextAreaProps> = function (props) {
    const { smartText = "", onTextChange } = props;

    const textArea = (
        <Input.TextArea
            rows={3}
            size="small"
            placeholder="可将收货人信息复制到这里然后点击“一键识别”"
            style={{ width: "100%" }}
            onChange={(e) => {
                onTextChange(e.target.value);
            }}
            value={smartText}
        />
    );

    const hasVirtualMobileRegExp = new RegExp(
        /(.*)(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}-(\d{4})(.*)/,
    );

    const showPopup = hasVirtualMobileRegExp.test(smartText);

    if (!showPopup) return textArea;

    return (
        <Popover
            open={true}
            content={
                <div className="error" style={{ width: 550 }}>
                    录入虚拟号后，为正常获取单号，保存订单时发货易会转换成固定格式(例如：姓名[xxxx]，详细地址[xxxx])。软件不承担因录入错误的虚拟号导致快递配送错误造成的损失
                </div>
            }
            zIndex={99}
        >
            {textArea}
        </Popover>
    );
};

export default React.memo(RecognizeAddressTextArea);
